import React from "react";
import { useTranslation } from "react-i18next";

import { useGame } from "context/gameContext";
import {
  IonPage,
  IonContent,
  IonToolbar,
  IonHeader,
  IonTitle,
  IonButtons,
  IonButton,
  IonMenu,
  IonMenuToggle,
  IonBadge,
  IonItem,
  IonLabel,
} from "@ionic/react";
import { Md2Bell, Md2BellAlert, Md2BellCircle } from "react-icons-ng/md2";
import { use } from "i18next";
import AppLogo from "components/appLogo";
import SiteBanner from "components/siteBanner";
import PremiumAd from "components/premiumAd";

const Header = () => {
  const { t } = useTranslation();
  const {
    state: { messages, premium, gameUsers },
  } = useGame();
  let bellCount = messages?.length ? messages?.length : null;

  return (
    <IonHeader
      mode="ios"
      className="ion-no-border"
      // translucent={true}
      id="main-content"
    >
      <IonToolbar className="gradientToolbarPrimary" mode="ios">
        <IonTitle>
          <div className="flex items-center justify-center animate-wiggle">
            <AppLogo size={"small"} />
          </div>
        </IonTitle>
        <IonButtons slot="end">
          <IonMenuToggle>
            <IonButton
              detail="false"
              expand="block"
              className="customButton noOpacity"
            >
              <IonLabel>
                <Md2Bell className="h-6 w-6 shrink-0 text-white" />
              </IonLabel>
              {bellCount && (
                <IonBadge
                  slot="end"
                  className="absolute -right-1 top-0 text-xs flex items-center justify-center rounded-full h-4 w-4 bg-black text-white animate-pulse"
                >
                  {bellCount}
                </IonBadge>
              )}
            </IonButton>
          </IonMenuToggle>
        </IonButtons>
      </IonToolbar>

      <SiteBanner />
      <PremiumAd />
    </IonHeader>
  );
};

export default Header;
